import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import userManager from "../helpers/UserManager";
import strings from "../helpers/Localization";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Loader from "../aGlobalDesign/Loader/Loader";

class LoginCallback extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = { redirectTo: null };
    }

    async componentDidMount() {
        this._isMounted = true;

        try {
            const user = await userManager.signinRedirectCallback();

            localStorage.setItem("UserIsLogged", "true");

            const redirectTo = null;
            if (user && user.state) {
                this.setState({ redirectTo: user.state });
            }
            else if (this.props.currentuser && this.props.currentuser.currentorganization) {
                this.setState({ redirectTo: "/dashboard" });
            }
            else {
                this.setState({ redirectTo: "/login" });
            }

            if (this._isMounted) {this.setState({ redirectTo });}

            this.props.GetCurrentUser(() => {
                this.props.GetConfigurations(() => {
                    const finalRedirect = this.state.redirectTo || "/login";

                    this.props.history.push(finalRedirect);
                });
            });
        }
        catch (err) {
            console.error("Login callback error:", err);
            this.props.history.push("/login");
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="defaultPageContent">
                <div className="defaultPageWrapper">
                    <Stack alignItems="center" justifyContent="Center" style={{ height: "100%" }}>
                        <div style={{ textAlign: "center", marginTop: "70px" }}>
                            <Typography
                                className="noselect"
                                style={{ flex: 1, marginBottom: "20px" }}
                                variant="h6"
                                noWrap
                            >
                                {strings.loggingIn}
                            </Typography>
                            <Loader dimensions="40px" color={"var(--primary-base)"} />
                        </div>
                        <span style={{ height: "200px" }} />
                    </Stack>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(ActionsCreators, dispatch);

export default withRouter(connect((state) => state, mapDispatchToProps)(LoginCallback));
